import { useEffect } from 'react'
import { __KPIPeriods } from '../../../common/Dictionaries';

const useManipulateCalendarType = (calendarConfig, setCalendarConfig, elementType, isPanelOpen, measurementPeriodId, setObjDataserieValue) => {    
    useEffect(()=> {
        const getData = async () => {
            setCalendarConfig && setCalendarConfig(prevState => ({
                ...prevState,
                maxDetail: elementType === "hour" || elementType === "shift" || elementType === "any" || elementType === "month" ? "month" : (elementType === "decade" ? "decade" : "year"),//decade, year, month
            })) 

            let measurementType = __KPIPeriods.find(x => x.key === measurementPeriodId).type;
            let aux_obj = {};
            const currentDate = new Date();
            const currentYear = currentDate.getFullYear()
            const currentMonth = currentDate.getMonth()
            const currentDay = currentDate.getDate()

            switch (measurementType) {
                case "decade":
                    aux_obj.serieTime = new Date(currentYear, 0, 1, 0, 0, 0, 1)
                    aux_obj.yyyy = aux_obj.serieTime.getFullYear();
                    break;
                case "year":
                    aux_obj.serieTime = new Date(currentYear, currentMonth, 1, 0, 0, 0, 1)
                    aux_obj.yyyy = aux_obj.serieTime.getFullYear();
                    aux_obj.mm = aux_obj.serieTime.getMonth();
                    break;
                case "month":
                    aux_obj.serieTime = new Date(currentYear, currentMonth, currentDay, 0, 0, 0, 1)
                    aux_obj.yyyy = aux_obj.serieTime.getFullYear();
                    aux_obj.mm = aux_obj.serieTime.getMonth();
                    aux_obj.dd = aux_obj.serieTime.getDate();
                    break;
                case "hour":
                    aux_obj.serieTime = new Date(currentYear, currentMonth, currentDay, 0, 0, 0, 1)
                    aux_obj.yyyy = aux_obj.serieTime.getFullYear();
                    aux_obj.mm = aux_obj.serieTime.getMonth();
                    aux_obj.dd = aux_obj.serieTime.getDate();
                    break;
                case "shift":
                    aux_obj.serieTime = new Date(currentYear, currentMonth, currentDay, 0, 0, 0, 1)
                    aux_obj.yyyy = aux_obj.serieTime.getFullYear();
                    aux_obj.mm = aux_obj.serieTime.getMonth();
                    aux_obj.dd = aux_obj.serieTime.getDate();
                    break;                  
                default:
                    break;
            }
    
            setObjDataserieValue && setObjDataserieValue(prevState => ({
                ...prevState,               
                dd : aux_obj.dd !== undefined ? aux_obj.dd : null,
                mm : aux_obj.mm !== undefined ? aux_obj.mm : null,
                yyyy : aux_obj.yyyy !== undefined ? aux_obj.yyyy : null,
                serieTime : aux_obj.serieTime,
                locked : false,
                closeProcessId : null,
            }))
        }

        if (calendarConfig.maxDetail === null && elementType !== null && measurementPeriodId !== null && isPanelOpen) {
            getData()
        }
    }, [calendarConfig, setCalendarConfig, elementType, isPanelOpen, measurementPeriodId, setObjDataserieValue]);
}

export {
    useManipulateCalendarType
}